import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import workflowStyles from "../../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import TalkToAgentPopup from './assignAgent/talkToAgentPopup';
import { getTalkToAgentDescriptionText } from '../../flowBuilderConstants';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';

const TalkToAgentComponent = (props: any) => {

    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)'); 

    const [flagAssignAgentPopup, setFlagAssignAgentPopup] = useState<boolean>(false);
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                Assign Agent
                            </Grid>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${workflowStyles.resetVariableText}`}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item className={globalStyles.wordBreakBreakWord}>
                                        {getTalkToAgentDescriptionText(customVariableList, actionData?.condition_group, actionData?.assignment_strategy_type)?.descriptionTextInLeftSection}
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon className={styles.editActionIcon} onClick={() => { setFlagAssignAgentPopup(true); }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {flagAssignAgentPopup &&
                    <GlobalPopUp
                        open={flagAssignAgentPopup}
                        onClose={() =>  {setFlagAssignAgentPopup(false);}}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "280px" : "850px"}
                        paperMaxwidth={flagSmallScreen ? "580px" : "950px"}
                        flagShowCloseIcon={true}
                        // height={"100%"}
                        titlePadding='0'
                        handleClose={() => { setFlagAssignAgentPopup(false); }}
                    >
                        <TalkToAgentPopup actionData={actionData} stepAction={stepAction} setFlagAssignAgentPopup={setFlagAssignAgentPopup} />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default TalkToAgentComponent
